<nav class="nav nav-pills flex-column flex-sm-row">
    <a class="flex-sm-fill text-sm-center nav-link" aria-current="page"
        [routerLink]="['/inventory', 'vehicles', 'vin', 'lookup']" routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact : true}">Vehicle</a>
    <a class="flex-sm-fill text-sm-center nav-link" [routerLink]="['/inventory', inventoryId, 'edit', 'media']"
        routerLinkActive="active">Media</a>
    <!-- <a class="flex-sm-fill text-sm-center nav-link disabled">Equipment</a> -->
    <a class="flex-sm-fill text-sm-center nav-link" [routerLink]="['/inventory', inventoryId, 'edit', 'costs']"
        routerLinkActive="active">Vehicle Costs</a>
    <a class="flex-sm-fill text-sm-center nav-link" [routerLink]="['/inventory', inventoryId, 'edit', 'publish']"
        routerLinkActive="active">Publish</a>
</nav>
